import api from "@/configs/axios-config";

export type Dimension = {
  id: number;
  dimension_name: string;
};

export const getDimensions = async (): Promise<Dimension[]> => {
  const res = await api.get("/dimensions/list");
  return res.data;
};

export type Master = {
  id: number;
  name: string;
  description: string;
  is_active: boolean;
  created_at: string;
  created_by: string;
  updated_at: string;
  updated_by: string;
};

export type getMasterParams = {
  skip?: number;
  limit?: number;
  search?: string;
  active_only?: boolean;
};

export const getOEMProcesses = async (param: getMasterParams) => {
  const params = {
    skip: 0,
    limit: 1000,
    active_only: false,
    ...param
  };

  const response = await api.get("/master-process/oem-process/", { params });
  return response.data?.data;
};

export const createOEMProcess = async (data: Master) => {
  const response = await api.post("/master-process/oem-process/", data);
  return response.data;
}

export const updateOEMProcess = async (data: Master) => {
  const response = await api.put(`/master-process/oem-process/${data.id}/`, data);
  return response.data;
}

export const getOEMPartProcesses = async (param: getMasterParams) => {
  const params = {
    skip: 0,
    limit: 1000,
    active_only: false,
    ...param
  };

  const response = await api.get("/master-process/oem-part-process/", { params });
  return response.data?.data;
};

export const createOEMPartProcess = async (data: Master) => {
  const response = await api.post("/master-process/oem-part-process/", data);
  return response.data;
}

export const updateOEMPartProcess = async (data: Master) => {
  const response = await api.put(`/master-process/oem-part-process/${data.id}/`, data);
  return response.data;
}

export const getOEMPartOtherProcesses = async (param: getMasterParams) => {
  const params = {
    skip: 0,
    limit: 1000,
    active_only: false,
    ...param
  };

  const response = await api.get("/master-process/oem-part-other-process/", { params });
  return response.data?.data;
};

export const createOEMPartOtherProcess = async (data: Master) => {
  const response = await api.post("/master-process/oem-part-other-process/", data);
  return response.data;
}

export const updateOEMPartOtherProcess = async (data: Master) => {
  const response = await api.put(`/master-process/oem-part-other-process/${data.id}`, data);
  return response.data;
}


export const getSpareProcesses = async (param: getMasterParams) => {
   const params = {
    skip: 0,
    limit: 1000,
    active_only: false,
    ...param
  };

  const response = await api.get("/master-process/spare-process/", { params });
  return response.data?.data;
}

export const createSpareProcess = async (data: Master) => {
  const response = await api.post("/master-process/spare-process/", data);
  return response.data;
}

export const updateSpareProcess = async (data: Master) => {
  const response = await api.put(`/master-process/spare-process/${data.id}/`, data);
  return response.data;
}

export const getSparePartProcesses = async (param: getMasterParams) => {
   const params = {
    skip: 0,
    limit: 1000,
    active_only: false,
    ...param
  };

  const response = await api.get("/master-process/spare-part-process/", { params });
  return response.data?.data;
}

export const createSparePartProcess = async (data: Master) => {
  const response = await api.post("/master-process/spare-part-process/", data);
  return response.data;
}

export const updateSparePartProcess = async (data: Master) => {
  const response = await api.put(`/master-process/spare-part-process/${data.id}`, data);
  return response.data;
}

export const getSparePartOtherProcesses = async (param: getMasterParams) => {
   const params = {
    skip: 0,
    limit: 1000,
    active_only: false,
    ...param
  };

  const response = await api.get("/master-process/spare-part-other-process/", { params });
  return response.data?.data;
}

export const createSparePartOtherProcess = async (data: Master) => {
  const response = await api.post("/master-process/spare-part-other-process/", data);
  return response.data;
}

export const updateSparePartOtherProcess = async (data: Master) => {
  const response = await api.put(`/master-process/spare-part-other-process/${data.id}/`, data);
  return response.data;
}

export const getMaterialOtherProcesses = async (param: getMasterParams) => {
   const params = {
    skip: 0,
    limit: 1000,
    active_only: false,
    ...param
  };

  const response = await api.get("/master-process/material-other-process/", { params });
  return response.data?.data;
}

export const createMaterialOtherProcess = async (data: Master) => {
  const response = await api.post("/master-process/material-other-process/", data);
  return response.data;
}

export const updateMaterialOtherProcess = async (data: Master) => {
  const response = await api.put(`/master-process/material-other-process/${data.id}/`, data);
  return response.data;
}

export const getMaterial2ndTierProcesses = async (param: getMasterParams) => {
   const params = {
    skip: 0,
    limit: 1000,
    active_only: false,
    ...param
  };

  const response = await api.get("/master-process/material-2nd-tier-process/", { params });
  return response.data?.data;
}

export const createMaterial2ndTierProcess = async (data: Master) => {
  const response = await api.post("/master-process/material-2nd-tier-process/", data);
  return response.data;
}

export const updateMaterial2ndTierProcess = async (data: Master) => {
  const response = await api.put(`/master-process/material-2nd-tier-process/${data.id}/`, data);
  return response.data;
}

export const getChildPartProcesses = async (param: getMasterParams) => {
   const params = {
    skip: 0,
    limit: 1000,
    active_only: false,
    ...param
  };

  const response = await api.get("/master-process/child-part-process/", { params });
  return response.data?.data;
}

export const createChildPartProcess = async (data: Master) => {
  const response = await api.post("/master-process/child-part-process/", data);
  return response.data;
}

export const updateChildPartProcess = async (data: Master) => {
  const response = await api.put(`/master-process/child-part-process/${data.id}`, data);
  return response.data;
}

export const getSupplier2nd = async (param: getMasterParams): Promise<Array<Master>> => {
  const params = {
    skip: 0,
    limit: 1000,
    active_only: false,
    ...param
  };

  const response = await api.get("/master-system/supplier-2nd/", { params });
  return response.data?.data;
}

export const createSupplier2nd = async (data: Master) => {
  const response = await api.post("/master-system/supplier-2nd/", data);
  return response.data;
}

export const updateSupplier2nd = async (data: Master) => {
  const response = await api.put(`/master-system/supplier-2nd/${data.id}`, data);
  return response.data;
}

export const getReturnScrap = async (param: getMasterParams): Promise<Array<Master>> => {
  const params = {
    skip: 0,
    limit: 1000,
    active_only: false,
    ...param
  };

  const response = await api.get("/scrap-prices/return-scrap/", { params });
  return response.data?.data;
}

export const createReturnScrap = async (data: Master) => {
  const response = await api.post("/scrap-prices/return-scrap/", data);
  return response.data;
}

export const updateReturnScrap = async (data: Master) => {
  const response = await api.put(`/scrap-prices/return-scrap/${data.id}`, data);
  return response.data;
}

export type ReturnScrapPrice = {
  year: number;
  scrap_prices: Array<{
    quarter: number;
    data: Array<{
      ms_return_scrap_id: number;
      price: string;
      scrap_price_id: number;
    }>;
  }>;
}

export type CreateBasePriceBody = {
  year: number;
  quarter: number;
  prices: Array<{
    ms_return_scrap_id: number;
    price: number;
  }>;
  is_buyer_flagged: boolean;
};

export type UpdateBasePriceBody = {
  updates: Array<{
    scrap_price_id: number;
    price: number;
  }>;
  is_buyer_flagged: boolean;
};

export type CreateQuarterBody = {
  target_year: number;
  target_quarter: number;
};

export const getReturnScrapPrice = async (year: number): Promise<ReturnScrapPrice> => {
  const response = await api.get(`/scrap-prices/data/${year}`);
  return response.data;
}

export const createScrapPrices = async (data: CreateBasePriceBody) => {
  const response = await api.post("/scrap-prices/bulk", data);
  return response.data;
}

export const updateScrapPrices = async (data: UpdateBasePriceBody) => {
  const response = await api.put("/scrap-prices/bulk", data);
  return response.data;
}

export const createNewQuarterScrapPrice = async (params: CreateQuarterBody) => {
  const response = await api.post(`/scrap-prices/create-new-quarter`, params);
  return response.data;
};

export type ReasonPriceChange = Master & {
  is_admin_reason: boolean;
};

export const getReasonPriceChange = async (param: getMasterParams): Promise<Array<ReasonPriceChange>> => {
  const params = {
    skip: 0,
    limit: 1000,
    active_only: false,
    ...param
  };

  const response = await api.get("/master-system/reason-price-change/", { params });
  return response.data?.data;
}

export const createReasonPriceChange = async (data: Master) => {
  const response = await api.post("/master-system/reason-price-change/", data);
  return response.data;
}

export const updateReasonPriceChange = async (data: Master) => {
  const response = await api.put(`/master-system/reason-price-change/${data.id}`, data);
  return response.data;
}